import { styled } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';

export const ErrorContainer = styled('div')(
  ({ theme }: { theme: ICustomTheme }) => ({
    display: 'flex',
    flex: '1 0 auto',
    alignItems: 'center',
    margin: theme.spacing(3, 'auto'),
    width: '60em',
    maxWidth: '100%',
  }),
);

export const StyledCircularProgressContainer = styled('div')(() => ({
  display: 'flex',
  flexGrow: 1,
  justifyContent: 'center',
  alignItems: 'center',
}));

export const StyledCircularProgress = styled(CircularProgress)(
  ({ theme }: { theme: ICustomTheme }) => ({
    color: theme.colors.paletteFromBO.main,
  }),
);
